import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Space, Typography, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { SelectItem } from "../../components/selectItem";
import { IMAGES } from "../../constants/images";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { getConsentimentos, addConsentimentos } from "../../api/consentimentos";
const { Text, Title } = Typography;

const styles = {
  row: {
    padding: "1%",
  },
};

const Consentimentos = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();

  // DADOS
  const [dados, setDados] = useState([]);
  const [formData, setData] = useState([]);

  useEffect(() => {
    carregarConsentimentos();
  }, []);

  useEffect(() => {
    let items = {};
    for (let i = 0; i < dados?.length; i++) {
      for (let iv = 0; iv < dados[i].itens.length; iv++) {
        let ids = dados[i].itens[iv].id;
        let val = dados[i].itens[iv].status === 1 || dados[i].itens[iv].obrigatorio === 1 ? true : false;
        items[ids] = val;
      }
    }
    setData(items);
  }, [dados]);

  // ENVIAR LIBERAÇÃO
  const salvarConsentimentos = async () => {
    setLoading(true);

    let array = [];

    Object.keys(formData).forEach(function (key) {
      array.push({ id: key, value: formData[key] });
    });

    try {
      const retorno = await addConsentimentos({ itens: array });
      if (retorno?.statusCode === 200) {
        message.success("Consentimentos atualizados com sucesso!");
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  // CARREGAR ITENS
  const carregarConsentimentos = async () => {
    setLoading(true);
    try {
      const retorno = await getConsentimentos();
      if (retorno?.statusCode === 200) {
        setDados(retorno?.response?.data);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={24} sm={24} md={18} lg={16} xl={12} xxl={10}>
        <Card bordered={false} bodyStyle={{ padding: "3%" }}>
          <Space direction="vertical" className="full-width" size={20}>
            <Layout.Content align="center">
              <img width={140} src={IMAGES?.consentimentos} className="resize-contain" />
            </Layout.Content>

            <Title className="title" align="center">
              Consentimentos
            </Title>

            <Text> Selecione abaixo as ações que a Copérdia poderá realizar através do seu concentimento. </Text>

            <Space direction="vertical" size={5} defaultValue={[6]}>
              {dados.map((item, index_group) => (
                <Space direction="vertical" key={index_group} size={20}>
                  <Text>{item.origem_descricao}</Text>
                  {item.itens.map((i) => (
                    <SelectItem
                      key={i.id}
                      checked={formData[i.id] ? true : false}
                      disabled={loading || i.obrigatorio}
                      onChange={() => {
                        if (!i.obrigatorio) {
                          setData((e) => ({ ...e, [i.id]: e[i.id] ? false : true }));
                        }
                      }}
                      title={i.descricao}
                      text={i.texto}
                    />
                  ))}
                </Space>
              ))}
            </Space>

            <Space>
              <Button icon={<ArrowLeftOutlined />} disabled={loading} size="large" onClick={() => navigate(-1)}>
                Voltar
              </Button>
              <Button disabled={loading} size="large" type="primary" onClick={salvarConsentimentos}>
                Atualizar
              </Button>
            </Space>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default Consentimentos;
